import { RequestModelInterface } from "@/service/models/request-model-interface";
import { DayTime } from "@/utilities/types/day-time";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { Target } from "../../response/drug-model-detail/target/target";

export class DrugTarget implements RequestModelInterface
{
    public constructor(
        public activeMoietyId: string,
        public type: Target.Type,
        public unit: string,
        public min: number,
        public best: number,
        public max: number,
        public inefficacyAlarm: number|null,
        public toxicityAlarm: number|null,
        public tMin: DayTime|null,
        public tBest: DayTime|null,
        public tMax: DayTime|null,
        public micUnit: string|null,
        public micValue: number|null,
    )
    {
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("target");

        element.appendNewElement("activeMoietyId", this.activeMoietyId);
        element.appendNewElement("targetType", this.type);
        element.appendNewElement("unit", this.unit);
        element.appendNewElement("min", this.min.toString());
        element.appendNewElement("best", this.best.toString());
        element.appendNewElement("max", this.max.toString());

        if (this.inefficacyAlarm !== null) {
            element.appendNewElement("inefficacyAlarm", this.inefficacyAlarm.toString());
        }
        if (this.toxicityAlarm !== null) {
            element.appendNewElement("toxicityAlarm", this.toxicityAlarm.toString());
        }

        if (this.tMin !== null) {
            element.appendNewElement("tMin", this.tMin.toString());
        }

        if (this.tBest !== null) {
            element.appendNewElement("tBest", this.tBest.toString());
        }

        if (this.tMax !== null) {
            element.appendNewElement("tMax", this.tMax.toString());
        }

        if (this.micUnit !== null && this.micValue !== null) {
            const micElement = doc.createElement("mic");
            micElement.appendNewElement("unit", this.micUnit);
            micElement.appendNewElement("micValue", this.micValue.toString());

            element.append(micElement);
        }

        return element;
    }
}
